import {Component, OnInit, ViewChild, Output, EventEmitter, HostListener} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ConstantsService} from '../../../../services/constants.service';
import {Company} from '../../../../types/admin-data.types';
import {ManagementCompanyService} from '../services/management-company.service';
import {UrlService} from '../../../../services/url.service';
import {ApiClientService} from '../../../../services/api-client.service';

declare const swal;
declare const toastr;

@Component({
    selector: 'company-modal',
    templateUrl: 'company-modal.component.html',
    styleUrls: ['company-modal.component.scss']
})
export class CompanyModalComponent implements OnInit {
    @Output() onClose = new EventEmitter();
    @ViewChild('form') form;

    public data: Company = new Company();
    public disabledSubmit = false;
    public themesList: Array<any> = [];
    public theme = '';

    constructor(public urlService: UrlService,
                public api: ApiClientService,
                private managementCompany: ManagementCompanyService) {
    }

    ngOnInit() {
        this.themesList = this.managementCompany.getAllThemes();
        if(this.themesList.find(theme => theme.name.toLowerCase() == 'default'))
            this.theme = this.themesList.find(theme => theme.name.toLowerCase() == 'default').id;
        this.urlService.modalOpened.emit();
    }

    close() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => this.onClose.emit()
            );
        } else {
            this.onClose.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.name) toastr.warning('Name should not be blank.');
            // if (!form.value.email) toastr.warning('Email should not be blank.');
            // if (!form.value.address) toastr.warning('Address should not be blank.');
            // if (!form.value.phone) toastr.warning('Phone should not be blank.');
            // if (!form.value.primaryContact) toastr.warning('Primary contact should not be blank.');
            return;
        }

        const data: any = {
            name: form.value.name.trim(),
            email: form.value.email.trim(),
            address: form.value.address.trim(),
            phone: form.value.phone.trim(),
            primaryContact: form.value.primaryContact.trim(),
            loginpage: form.value.loginpage.trim(),
            theme: form.value.theme,
        };

        this.disabledSubmit = true;

        this.managementCompany.create(data).subscribe(
            () => this.updateView('Company successfully created'),
            (error) => {
                this.api.errorHandler(error);
                try {
                    const body = JSON.parse(error._body);
                    const errorFields = Object.keys(body.fields);
                    Array.prototype.forEach.call(document.querySelectorAll(`.company-modal input`), input => {
                        input.classList.remove('ng-invalid');
                    });
                    errorFields.forEach(field => {
                        document.querySelector(`.company-modal input[name=${field}]`).classList.add('ng-invalid');
                        toastr.error(`${field}: ${body.fields[field].errors[0].description}`);
                    });
                    this.disabledSubmit = false;
                } catch(err) {
                    this.form.reset();
                    this.onClose.emit();
                    this.api.errorHandler(err, 'Company create failed.');
                }
            }
        );

    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.managementCompany.getCompanies();
        this.form.reset();
        this.onClose.emit();
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.close(), 100);
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/admin/management-company/company-modal/company-modal.component.ts